import { Clickable, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { colors, media, mediaQueries } = theme;

export const Container = styled.div`
  padding: 3rem 1rem 5rem 1rem;

  ${mediaQueries.above(media.md)} {
    padding: 5rem 6rem;
  }
`;

export const TilesWrapper = styled.div`
  display: grid;
  gap: 2rem;
  padding: 0;

  ${mediaQueries.above(media.md)} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${mediaQueries.above(media.lg)} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const PaginationItem = styled.li<{ isCurrentPage?: boolean }>`
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ isCurrentPage }) => (isCurrentPage ? colors.black : 'transparent')};
  color: ${({ isCurrentPage }) => (isCurrentPage ? colors.white : colors.black)};
  border-radius: ${({ isCurrentPage }) => (isCurrentPage ? '50%' : '0')};
`;

export const PaginationLink = styled(Clickable)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
